(ns arthur.ui.snapshots
  "Named versions. Every edit saves itself, so there is nothing to save — only
  moments worth a name, to go back to."
  (:require [arthur.events.collab :as collab]
            [arthur.subs.playback :as playback]
            [clojure.string :as str]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn view []
  (r/with-let [open? (r/atom false)
               draft (r/atom "")]
    (let [{:keys [can-edit?]} @(rf/subscribe [::playback/project])
          rows @(rf/subscribe [::collab/snapshot-list])
          editable? (not (false? can-edit?))]
      [:div.menu-wrap
       [:button {:class (when @open? "on")
                 :on-click (fn [] (when-not @open? (rf/dispatch [::collab/snapshots]))
                             (swap! open? not))}
        "snapshots ▾"]
       (when @open?
         [:<> [:div.menu-scrim {:on-click #(reset! open? false)}]
          [:div.menu.menu-left
           (when editable?
             [:form.row {:on-submit (fn [e]
                                      (.preventDefault e)
                                      (rf/dispatch [::collab/snapshot
                                                    (or (not-empty (str/trim @draft)) "snapshot")])
                                      (reset! draft ""))}
              [:input {:placeholder "name this version" :value @draft :auto-focus true
                       :on-change #(reset! draft (.. % -target -value))}]
              [:button {:type "submit"} "take snapshot"]])
           [:h2 "snapshots"]
           (if (empty? rows)
             [:div.dim "none yet"]
             (doall
              (for [{:keys [id name author created] :as row} rows]
                ^{:key id}
                [:div.menu-item.static
                 [:span name [:span.sub (str author " · " (subs (str created) 0 16))]]
                 (when editable?
                   [:button.link {:on-click (fn [] (reset! open? false)
                                              (rf/dispatch [::collab/restore row]))}
                    "restore"])])))]])])))
